export enum DepositStep {
  Form = 'form',
  CreatePersonalIdentity = 'create-personal-identity',
  Response = 'response',
}
